import React, { useEffect } from 'react';
import { useNavigate, Outlet, Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, FileText, LogOut, Calendar, Pencil, Home, ExternalLink, Mail, Settings, BarChart3, Building2 } from 'lucide-react';

export const AdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (!token) {
      navigate('/cms');
    }
  }, [token, navigate]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    // '/login' ist der KUNDEN-Login — nach dem Admin-Logout gehoert man auf
    // die Admin-Anmeldung. '/admin' waere ein Umweg: ohne Token leitet das
    // Layout von dort sofort weiter. (2026-08-17)
    navigate('/admin/login');
  };

  if (!token) return null;

  const menuItems = [
    { icon: Pencil, label: 'Inhalte bearbeiten', path: '/admin/content', description: 'Texte, Bilder, Bereiche' },
    { icon: Calendar, label: 'Veranstaltungen', path: '/admin/events', description: 'Events & Tickets' },
    { icon: Building2, label: 'Raumbuchung', path: '/admin/booking', description: 'Räume, Buchungen, User' },
    { icon: Mail, label: 'Newsletter', path: '/admin/newsletter', description: 'KI-Newsletter & Abonnenten' },
    { icon: BarChart3, label: 'Analytics', path: '/admin/analytics', description: 'Besucherstatistiken' },
    { icon: Settings, label: 'Einstellungen', path: '/admin/settings', description: 'SEO, E-Mails, System' },
  ];

  return (
    <div className="flex h-screen bg-gray-50 font-sans">
      {/* Sidebar */}
      <div className="w-72 bg-black text-white flex flex-col">
        <div className="p-6 border-b border-gray-800">
          <div className="flex items-baseline">
            <span className="text-xl font-light tracking-tight">team</span>
            <span className="text-xl font-black tracking-tight">WERK</span>
          </div>
          <p className="text-xs text-gray-500 mt-1">Content Management</p>
        </div>
        
        <nav className="flex-1 p-4 space-y-1">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                location.pathname === item.path 
                  ? 'bg-white text-black' 
                  : 'text-gray-400 hover:bg-gray-900 hover:text-white'
              }`}
            >
              <item.icon size={20} />
              <div>
                <span className="font-medium block">{item.label}</span>
                <span className="text-xs opacity-60">{item.description}</span>
              </div>
            </Link>
          ))}
        </nav>

        <div className="p-4 border-t border-gray-800 space-y-2">
          <a 
            href="/" 
            target="_blank"
            className="flex items-center gap-3 px-4 py-3 w-full text-gray-400 hover:text-white hover:bg-gray-900 rounded-lg transition-colors"
          >
            <ExternalLink size={20} />
            <span>Website ansehen</span>
          </a>
          <button 
            onClick={handleLogout}
            className="flex items-center gap-3 px-4 py-3 w-full text-gray-500 hover:text-white hover:bg-gray-900 rounded-lg transition-colors"
          >
            <LogOut size={20} />
            <span>Abmelden</span>
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 overflow-auto bg-white">
        <Outlet />
      </div>
    </div>
  );
};
